// Scripts specifically for team members
(function($){
	//Listen for resource type slider value change
	$('.single-team-member #resource-type-select').change(function(e) {
		let selected = $(this).val();
		let $button = $('#resource-archive-button');
		let href = $button.data('original_url');

		//Filter the slides
		$('.related-resources-slider .slick-slider').slick('slickUnfilter');

		if (selected.length) {
			$('.related-resources-slider .slick-slider').slick('slickFilter', `.resource-type-${selected}`);
			href += `&resource-type=${selected}`;
		}

		//Update the button
		$button.attr('href', href);
	});
})(jQuery);
